import { DateRange } from '@mui/icons-material';
import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTime(date) {
    return format(new Date(date), 'HH:mm');
}

export function fTimestamp(timestamp) {
  return format(new Date(timestamp * 1000), 'dd MMM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: false,
  });
}

export function fTimeOrDate(date) {
  if (format(new Date(), 'dd MM yyyy') === format(new Date(date), 'dd MM yyyy')) {
    return format(new Date(date), 'HH:mm')
  }
  return format(new Date(date), 'dd MM yyyy')
}